export class Scroll {
    // eslint-disable-next-line no-useless-constructor
    constructor(page, listener) {
        this.page = page;
        this.listener = listener;
        this.enabled = false;
        this.scrollupdatedhandler = (ev) => this.capture(ev);
        this.preventScroll = new WeakMap();
        this.preventDispatch = new WeakMap();
    }
    track() {
        if (this.enabled) {
            return;
        }
        this.page
            .getWindow()
            .addEventListener("scroll", this.scrollupdatedhandler, true);
        this.enabled = true;
    }
    untrack() {
        var _a;
        (_a = this.page
            .getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener("scroll", this.scrollupdatedhandler, true);
        this.enabled = false;
    }
    dispatch(event, time) {
        const target = event.target
            ? this.page.idp.getNode(event.target)
            : this.page.getDocument();
        const scrollingElement = event.target
            ? target
            : this.page.getDocument().scrollingElement || this.page.getWindow();
        if (!scrollingElement || this.preventDispatch.get(target) > time) {
            return;
        }
        this.preventScroll.set(target, {
            until: Date.now() + Scroll.preventDuration,
            x: event.scrollX,
            y: event.scrollY,
            w: event.width,
            h: event.height,
        });
        this.scroll(scrollingElement, event.scrollX, event.scrollY, event.width, event.height);
    }
    isScrollable(elm) {
        return elm.scrollLeft || elm.scrollTop;
    }
    scroll(target, left, top, width, height) {
        if (left <= width && top <= height) {
            const scrollingElement = Number.isInteger(target.scrollHeight)
                ? target
                : this.page.getDocument().scrollingElement;
            if (width)
                left =
                    (left / width) *
                        (scrollingElement.scrollWidth - scrollingElement.clientWidth);
            if (height)
                top =
                    (top / height) *
                        (scrollingElement.scrollHeight - scrollingElement.clientHeight);
        }
        target.scroll({
            left,
            top,
            behavior: "instant",
        });
    }
    capture(ev) {
        const target = ev.target;
        const targetId = this.page.idp.getId(target);
        if (!targetId) {
            return;
        }
        const scrollingElement = target === this.page.getDocument()
            ? this.page.getDocument().scrollingElement || this.page.getWindow()
            : target;
        let left, top, width, height;
        if (scrollingElement === this.page.getWindow()) {
            left = Math.floor(scrollingElement.scrollX);
            top = Math.floor(scrollingElement.scrollY);
            width =
                this.page.getDocument().documentElement.scrollWidth -
                    this.page.getDocument().documentElement.clientWidth;
            height =
                this.page.getDocument().documentElement.scrollHeight -
                    this.page.getDocument().documentElement.clientHeight;
        }
        else {
            left = Math.floor(scrollingElement.scrollLeft);
            top = Math.floor(scrollingElement.scrollTop);
            width =
                scrollingElement.scrollWidth -
                    scrollingElement.clientWidth;
            height =
                scrollingElement.scrollHeight -
                    scrollingElement.clientHeight;
        }
        const isDocument = target === this.page.getDocument() ||
            target === this.page.getDocument().scrollingElement;
        const preventTarget = isDocument ? this.page.getDocument() : target;
        const prevent = this.preventScroll.get(preventTarget);
        if (!prevent || prevent.until <= Date.now()) {
            this.preventDispatch.set(preventTarget, Date.now() + Scroll.preventDuration);
            this.listener({
                target: isDocument ? 0 : targetId,
                scrollX: left,
                scrollY: top,
                height,
                width,
                init: "timeStamp" in ev || undefined,
            });
        }
        else if (left !== prevent.x || top !== prevent.y) {
            this.scroll(scrollingElement, prevent.x, prevent.y, prevent.w, prevent.h);
        }
    }
}
Scroll.preventDuration = 1000;
//# sourceMappingURL=scroll.js.map